import { Injectable } from '@angular/core';
import { Validators, FormControl } from '@angular/forms';
import { FicheConseilService } from 'src/app/services/fiche-conseil.service';

import { FormConfigService } from 'src/app/services/form-config.service';
import { FieldFormControl } from 'src/fieldFormControl/FieldFormControl';

export interface CtrlWrappers<TUI, TData> {
  toUI?: (data: TData | null | undefined) => TUI;
  toData?: (ui: TUI | null | undefined) => TData | null;
}

@Injectable({ providedIn: 'root' })
export class FieldControlFactory {
  constructor(
    private readonly formConfigService: FormConfigService,
    private readonly ficheConseilService: FicheConseilService
  ) {}

  makeCtrl<TUI, TData>(
    dataKey: string,
    defaultValue: TUI,
    opts?: { validators?: any[] } & CtrlWrappers<TUI, TData>
  ): FieldFormControl<TUI, TData> {
    return new FieldFormControl<TUI, TData>({
      formConfigService: this.formConfigService,
      ficheConseilService: this.ficheConseilService,
      dataKey,
      defaultValue,
      ficheDataToFieldDataWrapper: opts?.toUI,
      fieldDataToFicheDataWrapper: opts?.toData,
      options: opts?.validators ? { validators: opts.validators } : undefined,
    });
  }

  makeBoolCtrl(dataKey: string, def = false) {
    return this.makeCtrl<boolean, boolean>(dataKey, def);
  }

  makeAmountStringCtrl(dataKey: string, def: string | null = null, validators: any[] = [Validators.min(0)]) {
    return this.makeCtrl<string | null, number>(dataKey, def, {
      validators,
      toUI: v => ((v ?? null) === null ? null : String(v)),
      toData: ui => {
        if (ui == null || ui === '') return null;
        const num = Number(ui.toString().replace(/\s/g, '').replace(',', '.'));
        return Number.isFinite(num) ? num : null;
      },
    });
  }
}
